









import { Vue, Component, Prop } from "vue-property-decorator";

import UsersList from "@share/common/users-list/UsersList.vue";
import FittedUsersList from "@share/common/users-list/FittedUsersList.vue";
import EventCountdown from "@share/common/countdown/event-countdown/EventCountdown.vue";

import {Element} from "@api/models/Element";
import { UserProfile } from "@api/models/UserProfile";

@Component({
    components: { UsersList, EventCountdown, FittedUsersList }
})

export default class EventFooter extends Vue {
    @Prop({ required: true }) speakers: UserProfile[];
    @Prop({ required: false, default: null }) event: Element | null;
}
